import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../../services/auth.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-register-dialog',
  imports: [ButtonDirective, InputText, ReactiveFormsModule],
  templateUrl: './register-dialog.component.html',
  styleUrl: './register-dialog.component.scss',
})
export class RegisterDialogComponent implements OnInit {
  private auth = inject(AuthService);
  public ref = inject(DynamicDialogRef);
  private cfg = inject(DynamicDialogConfig);
  private initialEmail = (this.cfg?.data?.email as string | undefined) ?? '';
  public loading = signal(false);
  public error = signal<string | null>(null);

  ngOnInit(): void {
    const { email } = this.form.getRawValue();
    email === ''
      ? this.form.get('email')?.enable()
      : this.form.get('email')?.disable();
  }

  public form = new FormGroup({
    email: new FormControl<string>(this.initialEmail, {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    firstName: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    lastName: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  public onSubmit() {
    if (this.form.invalid || this.loading()) return;
    this.loading.set(true);
    this.error.set(null);

    const { email, password, firstName, lastName } = this.form.getRawValue();
    this.auth.register(email, password, firstName, lastName).subscribe({
      next: () => {
        this.loading.set(false);
        this.ref.close('success');
      },
      error: (err) => {
        this.loading.set(false);
        console.log('err', err?.error?.error);
        this.error.set(this.normalizeError(err));
      },
    });
  }

  openLoginDialog(): void {
    const { email } = this.form.getRawValue();
    this.loading.set(false);
    this.ref.close('login:' + email);
  }

  private normalizeError(err: any): string {
    const raw = err?.error?.error;

    if (!raw) return 'Nie udało się zarejestrować.';

    if (raw === 'UserAlreadyExistsException') {
      return 'Użytkownik o takim adresie już istnieje.';
    }

    if (typeof raw === 'string') {
      return raw
        .split('\n')
        .map((r) => r.trim())
        .filter((r) => r.length > 0)
        .map((r) => r.replace(/^password:\s*/i, '- '))
        .join('<br/>');
    }

    return 'Nie udało się zarejestrować.';
  }
}
